import type { MultiValue } from 'react-select';

import { Option } from '../Selects/Selector';

export const getOptionValues = (
  options: Option | MultiValue<Option> | null | undefined,
) => (options ? (options as Option[]).map(({ value }) => value) : []);

export const handleChangeSelection = async (
  option: Option | MultiValue<Option> | null | undefined,
  field1: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  propertyChange?: (obj: Partial<any>) => void,
  fieldUndefined?: string,
) => {
  if (option && (option as Option)?.value) {
    if (propertyChange) {
      if (fieldUndefined) {
        propertyChange({
          [field1]: (option as Option)?.value,
          [fieldUndefined]: null,
        });
      } else {
        propertyChange({ [field1]: (option as Option)?.value });
      }
    }
  }
};
